module.exports = __webpack_public_path__ + "d308073b/img/archive-icon.0a6a9de3.svg";